
import AutoNumeric from 'autonumeric';
import { IChartContainer } from "../base/chart-container.interface";
import { EMACloudSettingsModel } from "./ema-cloud-settings.model";
declare const $: any;

export class EMACloudUIManager {
    
    private base: IChartContainer;
    private containerElement: HTMLElement;
    private model = new EMACloudSettingsModel({
        displayBuySellFlags: true,
        displayOnlyLastTwoTrades: false,
        sectionCount: 0
    });
    private initExpandAll = false;

    constructor (base: IChartContainer, containerElement: HTMLElement, initExpandAll: boolean) {
        this.base = base;
        this.containerElement = containerElement;
        this.initExpandAll = initExpandAll;
    }

    public init(save: boolean) {
        const chartStyle = this.base.tiChartSeries.chartStyleSettings;
        this.model = new EMACloudSettingsModel({
            displayBuySellFlags: chartStyle.emaCloudDisplayBuySellFlags,
            displayOnlyLastTwoTrades: chartStyle.emaCloudDisplayOnlyLastTwoTrades,
            sectionCount: chartStyle.emaCloudSectionCount
        });
        this.tiIndicatorDataToEmaCloudSettingsModel();
        this.putSectionToContainer();
        this.onInputEvents();
        this.base.tiChartSeries?.highChartStyleBuilder?.createEMACloudStyle(this.model);

        setTimeout(() => {
            this.base.tiChartSeries?.highChartStyleBuilder?.createEMACloudStyle(this.model);
            if (save) {
                this.requestSaveSettings();
            }
        }, 500);
        
    }

    public requestSaveSettings() {
        //save
        if ($(this.containerElement).find(`#ema-cloud-settings-display-last-two-trades`).prop('checked')) {
            this.model.displayOnlyLastTwoTrades = true;
        } else {
            this.model.displayOnlyLastTwoTrades = false;
        }

        if (!this.base.marketingWebChartMode) {
            localStorage.setItem('TEMP_EMACloudDisplayBuySellFlags', this.model.displayBuySellFlags + '');
            localStorage.setItem('TEMP_EMACloudDisplayOnlyLastTwoTrades', this.model.displayOnlyLastTwoTrades + '');
        }

        this.base.chartService.requestSaveEMACloudSettings(this.model);
    }

    public revertSettings() {
        const chartStyle = this.base.tiChartSeries.chartStyleSettings;
        this.model = new EMACloudSettingsModel({
            displayBuySellFlags: chartStyle.emaCloudDisplayBuySellFlags,
            displayOnlyLastTwoTrades: chartStyle.emaCloudDisplayOnlyLastTwoTrades,
            sectionCount: chartStyle.emaCloudSectionCount
        });
        this.putSectionToContainer();
        this.onInputEvents();
    }

    private setDisplayOnlyLastTwoTrades(val: boolean) {
        if (!this.model.displayBuySellFlags)  {
            this.model.displayOnlyLastTwoTrades = false;
            return;
        }

        this.model.displayOnlyLastTwoTrades = val;
    }

    private setDisplayBuySellFlags(val: boolean) {
        this.model.displayBuySellFlags = val;
        if (this.model.displayBuySellFlags) {
            $(this.containerElement).find(`#ema-cloud-settings-display-last-two-trades`).removeAttr('disabled');

            if (this.model.displayOnlyLastTwoTrades) {
                // this.model.displayOnlyLastTwoTrades = true;
                $(this.containerElement).find(`#ema-cloud-settings-display-last-two-trades`).prop('checked', true);
            }
        } else {
            $(this.containerElement).find(`#ema-cloud-settings-display-last-two-trades`).prop('checked', false);
            $(this.containerElement).find(`#ema-cloud-settings-display-last-two-trades`).attr('disabled', 'disabled');
            // this.model.displayOnlyLastTwoTrades = false;
        }
    }

    private onInputEvents() {
        const ctx = this;

        $(this.containerElement).find(`#ema-cloud-settings-display-flags`).on('change', (e: any) => {
            this.setDisplayBuySellFlags($(e.target).prop('checked'));
        });

        $(this.containerElement).find(`#ema-cloud-settings-display-last-two-trades`).on('change', (e: any) => {
            this.setDisplayOnlyLastTwoTrades($(e.target).prop('checked'));
        });

        const sections = $(this.containerElement).find('.section');
        if (sections?.length) {
            for (let i = 0; i < sections.length; i++) {
                const s = sections[i];
                $(s).find(".font-size-picker-wrapper").off('click');
                $(s).find(".font-size-picker-wrapper").on('click', (e: any) => {
                    const hasActive = $(e.currentTarget).hasClass('active');
                    ctx.hideAllPickerControls();
                    if (!hasActive) {
                        $(e.currentTarget).addClass("active");
                    }
                });

                $(s).find(".font-size-picker li").off('click');
                $(s).find(".font-size-picker li").on('click', (e: any) => {
                    const value = $(e.currentTarget).html();
                    this.model.items[i].maType = value;
                    this.setMATypeToUI();
                });

                const extraClassName = this.base.tiChartSeries?.chartStyleSettings?.isDarkTheme ? 'dark' : '';
                $(s).find(".emacloudupcolorpicker.cloud-" + i).spectrum({
                    color: this.model.items[i].upColor,
                    showInput: true,
                    showAlpha: true,
                    containerClassName: extraClassName,
                    change: (color: any) => {
                        if (color) {
                            let hex = `rgba(${color._r.toString()},${color._g.toString()},${color._b.toString()},${color._a.toString()})`;
                            this.model.items[i].upColor = hex;
                            $(s).find('.ema-cloud-color-picker.up').css('background-color', hex);
                            $(s).find('.ema-cloud-color-picker.up').css('background-image', 'unset');
                        } else {
                            this.model.items[i].upColor = '';
                            $(s).find('.ema-cloud-color-picker.up').css('background-color', '');
                            $(s).find('.ema-cloud-color-picker.up').css('background-image', '');
                        }
                    }
                });

                $(s).find(".emaclouddowncolorpicker.cloud-" + i).spectrum({
                    color: this.model.items[i].downColor,
                    showInput: true,
                    showAlpha: true,
                    containerClassName: extraClassName,
                    change: (color: any) => {
                        if (color) {
                            let hex = `rgba(${color._r.toString()},${color._g.toString()},${color._b.toString()},${color._a.toString()})`;
                            this.model.items[i].downColor = hex;
                            $(s).find('.ema-cloud-color-picker.down').css('background-color', hex);
                            $(s).find('.ema-cloud-color-picker.down').css('background-image', 'unset');
                        } else {
                            this.model.items[i].downColor = '';
                            $(s).find('.ema-cloud-color-picker.down').css('background-color', '');
                            $(s).find('.ema-cloud-color-picker.down').css('background-image', '');
                        }
                    }
                });

                $(s).find(".ema-cloud-color-picker.up").on('click', () => {
                    if ($(this).hasClass('disabled')) return false;
                    $(s).find(".emacloudupcolorpicker.cloud-" + i).spectrum('toggle');
                    return false;
                });
                $(s).find(".ema-cloud-color-picker.down").on('click', () => {
                    if ($(this).hasClass('disabled')) return false;
                    $(s).find(".emaclouddowncolorpicker.cloud-" + i).spectrum('toggle');
                    return false;
                });

                $(s).find(`input[type="checkbox"]`).on('change', (e: any) => {
                    this.model.items[i].active = $(e.target).prop('checked');
                    if (this.model.items[i].active) {
                        this.enableSectionControl(s);
                    } else {
                        this.disableSectionControl(s);
                    }
                });

                const range = $(s).find(`input[type="range"]`)[0];
                if (range) {
                    $(range).on('change', (e: any) => {
                        this.model.items[i].opacity = parseInt($(e.target).val());
                    });

                    range.style.setProperty('--value', range.value);
                    range.style.setProperty('--min', range.min == '' ? '0' : range.min);
                    range.style.setProperty('--max', range.max == '' ? '100' : range.max);
                    range.addEventListener('input', () => range.style.setProperty('--value', range.value));
                }

                const fastInput = new AutoNumeric($(s).find(".control.fast input")[0], this.model.items[i].fast, {
                    decimalPlaces: 0
                });

                fastInput.node().addEventListener('keyup', () => {
                    this.model.items[i].fast = fastInput.getNumber();
                });

                const slowInput = new AutoNumeric($(s).find(".control.slow input")[0], this.model.items[i].slow, {
                    decimalPlaces: 0
                });

                slowInput.node().addEventListener('keyup', () => {
                    this.model.items[i].slow = slowInput.getNumber();
                });

                $(s).find(".section-head").on('click', (e: any) => {
                    if ($(e.target).hasClass('.checkbox-input') || $(e.target).closest('.checkbox-input')?.length) {
                        return;
                    }

                    const parent = $(e.target).closest('.section');
                    $(parent).toggleClass('active');
                });

                if (this.model.items[i].active) {
                    this.enableSectionControl(s);
                } else {
                    this.disableSectionControl(s);
                }
            }
        }
    }

    private enableSectionControl(section: any) {
        $(section).find('.slider-input').removeClass('disabled');
        $(section).find('.text-input').removeClass('disabled');
        $(section).find('.ema-cloud-color-picker').removeClass('disabled');
        $(section).find('.font-size-picker-wrapper').removeClass('disabled');
        $(section).find('.section-title').removeClass('disabled');
    }

    private disableSectionControl(section: any) {
        $(section).find('.slider-input').addClass('disabled');
        $(section).find('.text-input').addClass('disabled');
        $(section).find('.ema-cloud-color-picker').addClass('disabled');
        $(section).find('.font-size-picker-wrapper').addClass('disabled');
        $(section).find('.section-title').addClass('disabled');
    }

    private hideAllPickerControls() {
        $(this.containerElement).find(".font-size-picker-wrapper").removeClass('active');
    }

    private putSectionToContainer() {
        const sections = this.getSectionHTML();
        $(this.containerElement).html(sections);
    }

    private setMATypeToUI() {
        const sections = $(this.containerElement).find('.section');
        if (sections?.length) {
            for (let i = 0; i < sections.length; i++) {
                const s = sections[i];
                $(s).find(".font-size-picker li").removeClass('selected');
                $(s).find('.font-size-picker li[data-value="' + this.model.items[i].maType + '"]').addClass('selected');
                $(s).find('.font-size-picker .selected p').html(this.model.items[i].maType);
                $(s).find('.control.fast span').html('Fast ' + this.model.items[i].maType);
                $(s).find('.control.slow span').html('Slow ' + this.model.items[i].maType);

                $(s).find(".control.fast input").val(this.model.items[i].fast);
                $(s).find(".control.slow input").val(this.model.items[i].slow);

                $(s).find(`input[type="range"]`).val(this.model.items[i].opacity);

                $(s).find(".emacloudupcolorpicker").spectrum("set", this.model.items[i].upColor);
                $(s).find(".emaclouddowncolorpicker").spectrum("set", this.model.items[i].downColor);
            }
        }
    }

    private tiIndicatorDataToEmaCloudSettingsModel() {
        if (this.base.tiChartSeries.tiIndicatorsData?.length) {
            if (this.base.tiChartSeries.tiIndicatorsData.some(x => x.abbreviatedName.indexOf("EMACLOUD") > -1)) {
                for (const m of this.model.items) {
                    m.active = false;
                }
            }
            
            for (let i = 0; i < this.base.tiChartSeries.tiIndicatorsData.length; i++) {
                const indicator = this.base.tiChartSeries.tiIndicatorsData[i];
                if (indicator.abbreviatedName.indexOf("EMACLOUD") == -1) {
                    continue;
                }

                const abbreviatedNameSplits = indicator.abbreviatedName.split(',');
                const ind = parseInt(abbreviatedNameSplits?.[0]?.replace('EMACLOUD_', ''));
                const valueSplits = abbreviatedNameSplits?.[1]?.split('-');
                const m = this.model.items[ind];
                
                if (!m || !valueSplits?.length || valueSplits?.length <= 1) {
                    continue;
                }

                m.active = true;
                m.fast = parseInt(valueSplits[0], 10);
                m.slow = parseInt(valueSplits[1], 10);
                m.opacity = indicator.opacity;
                m.upColor = indicator.color;
                m.downColor = indicator.childIndicators?.[0]?.color ?? '';
            }
        }
    }

    private getSectionHTML(): string {
        let html = `
            <div class="mgb-16 checkbox-input">
                <input type="checkbox" class="mgr-8" ${this.model.displayBuySellFlags ? 'checked="checked"' : ''} id="ema-cloud-settings-display-flags" />
                <label for="ema-cloud-settings-display-flags">Display Buy and Sell Flags</label>
            </div>
            <div class="mgb-16 checkbox-input">
                <input type="checkbox" class="mgr-8" ${this.model.displayBuySellFlags && this.model.displayOnlyLastTwoTrades ? 'checked="checked"' : ''} ${this.model.displayBuySellFlags ? '' : 'disabled="disabled"'} id="ema-cloud-settings-display-last-two-trades" />
                <label for="ema-cloud-settings-display-last-two-trades">Display Only Last Two Trades</label>
            </div>`;

        let active = false;
        for (let i = 0; i < this.model.items.length; i++) {
            const m = this.model.items[i];
            let shouldActive = false;
            if (this.initExpandAll) {
                shouldActive = true;
            } else {
                if (!active && m.active) {
                    shouldActive = true;
                    active = true;
                }
            }

            html += `
            <div class="section ${shouldActive ? 'active' : ''}" data-index="${i}">
                <div class="section-head">
                    <div class="checkbox-input mgr-8">
                        <input type="checkbox" ${m.active ? 'checked="checked"' : ''} />
                    </div>
                    <p class="section-title">Cloud ${i + 1}</p>
                    <div class="section-arrow">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 7" width="11" height="7" fill="none">
                            <path stroke="currentColor" stroke-width="1.3" d="M.5 1.5l5 4 5-4"></path>
                        </svg>
                    </div>
                </div>
                <div class="section-content">
                    <div class="control">
                        <span class="label-inline" style="width: 80px; margin-right: 4px;">MA Type</span>
                        <div class="font-size-picker-wrapper mgr-8">
                            <div class="font-size-picker">
                                <div class="selected">
                                    <p>${m.maType}</p>
                                </div>
                                <div class="arrow">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 7" width="11" height="7"
                                        fill="none">
                                        <path stroke="currentColor" stroke-width="1.3" d="M.5 1.5l5 4 5-4"></path>
                                    </svg>
                                </div>
                                <ul class="selection">
                                    <li data-value="EMA" class="${m.maType === 'EMA' ? 'selected' : ''}">EMA</li>
                                    <li data-value="SMA" class="${m.maType === 'SMA' ? 'selected' : ''}">SMA</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="control fast">
                        <span class="label-inline" style="width: 80px; margin-right: 4px;">Fast EMA</span>
                        <div class="text-input mgr-8">
                            <input type="text" inputmode="decimal" pattern="[0-9]*" value="${m.fast}" />
                        </div>
                    </div>
                    <div class="control slow">
                        <span class="label-inline" style="width: 80px; margin-right: 4px;">Slow EMA</span>
                        <div class="text-input mgr-8">
                            <input type="text" inputmode="decimal" pattern="[0-9]*" value="${m.slow}" />
                        </div>
                    </div>
                    <div class="control">
                        <span class="label-inline" style="width: 80px; margin-right: 4px;">Up Color</span>
                        <div class="color-picker-wrapper mgr-8">
                            <div class="ema-cloud-color-picker up color-picker" style="background-color: ${m.upColor}; background-image: unset;">
                                <input class='emacloudupcolorpicker cloud-${i}' style="position: relative; top: 20px;height: 1px; width: 1px; visibility: hidden; opacity: 0;" />
                            </div>
                        </div>
                    </div>
                    <div class="control">
                        <span class="label-inline" style="width: 80px; margin-right: 4px;">Down Color</span>
                        <div class="color-picker-wrapper mgr-8">
                            <div class="ema-cloud-color-picker down color-picker" style="background-color: ${m.downColor}; background-image: unset;">
                                <input class='emaclouddowncolorpicker cloud-${i}' style="position: relative; top: 20px;height: 1px; width: 1px; visibility: hidden; opacity: 0;" />
                            </div>
                        </div>
                    </div>
                    <div class="control">
                        <span class="label-inline" style="width: 80px; margin-right: 4px;">Opacity</span>
                        <div class="slider-input mgr-8">
                            <input type="range" class="styled-slider slider-progress" min="15" max="100" value="${m.opacity}">
                        </div>
                    </div>
                </div>
            </div>`;
        }

        return html;
    }
}